import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { FaChevronDown, FaChevronUp } from 'react-icons/fa'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch, RootState } from '../../store'
import { fetchSubCategoryByCategory } from '../../features/admin/placeSlice'
import { fetchServices } from '../../features/admin/serviceSlice'

type FilterSectionProps = {
    title: string
    options: { label: string; value: string; }[]
    selected: string[]
    onChange: (value: string) => void
    collapsible?: boolean
    showMoreCount?: number
}

export const FilterSection = ({ title, options, selected, onChange, collapsible = true, showMoreCount = 5, }: FilterSectionProps) => {
    const [open, setOpen] = useState(true)
    const [showMore, setShowMore] = useState(false)
    const visibleOptions = showMore ? options : options?.slice(0, showMoreCount)
    return (
        <div className="mb-4 border-b pb-4">
            <div
                className="flex justify-between items-center cursor-pointer mb-2"
                onClick={() => collapsible && setOpen(!open)}
            >
                <h3 className="font-semibold text-sm">{title}</h3>
                {collapsible &&
                    (open ? (
                        <FaChevronUp className="text-xs" />
                    ) : (
                        <FaChevronDown className="text-xs" />
                    ))}
            </div>

            {open && (
                <div className="space-y-2">
                    {visibleOptions?.map((opt) => (
                        <label key={opt.value} className="flex items-center space-x-2 gap-1 text-sm">
                            <input
                                type="checkbox"
                                checked={
                                    Array.isArray(selected)
                                        ? selected.includes(opt.value)
                                        : selected === opt.value
                                }
                                onChange={() => onChange(opt.value)}
                                className="accent-secondry"
                            />
                            <span>
                                {opt.label}
                            </span>
                        </label>
                    ))}

                    {options?.length > showMoreCount && !showMore && (
                        <button
                            className="text-xs text-blue-600 mt-1"
                            onClick={() => setShowMore(true)}
                        >
                            See More ({options.length - showMoreCount}) ▼
                        </button>
                    )}
                </div>
            )}
        </div>
    )
}

const FiltersSidebar = ({ openFilter, setOpenFilter, filters, setFilters, type }: { type: string, openFilter: boolean, setOpenFilter: any, filters: any, setFilters: (val: any) => void }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch<AppDispatch>()
    const { subCategories } = useSelector((state: RootState) => state.placeSlice)
    const { services } = useSelector((state: RootState) => state.serviceSlice)
    useEffect(() => {
        type === "Stay" ? dispatch(fetchSubCategoryByCategory(1)) : dispatch(fetchSubCategoryByCategory(4));
        dispatch(fetchServices())
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch])


    // تحديث الخدمات
    const handleFacilityChange = (value: string) => {
        const val = Number(value);
        const newServices = filters.services.includes(val)
            ? filters.services.filter((v: number) => v !== val)
            : [...filters.services, val];

        setFilters({ ...filters, services: newServices });
    };

    const handleTypeChange = (value: string) => {
        setFilters({
            ...filters,
            subCategoryId: Number(value),
            numberOfPlaceRooms: null,
            numberOfHalls: null,
        });
    };

    const handleRatingChange = (value: string) => {
        setFilters({ ...filters, rate: Number(value) });
    };
    const handleDurationChange = (value: string) => {
        setFilters({ ...filters, duration: Number(value) });
    };

    const handlePriceChange = (value: string) => {
        let min = 0;
        let max = 0;
        if (value === '10000') {
            min = 10000;
            max = 1000000;
        } else {
            const parts = value.split("-");
            min = +parts[0];
            max = +parts[1];
        }
        setFilters({ ...filters, minPrice: min, maxPrice: max });
    };
    const handleRoomHallChange = (value: string) => {
        if (value === 'all') {
            setFilters({
                ...filters,
                numberOfPlaceRooms: null,
                numberOfHalls: null,
            });
            return;
        }

        const [numberOfPlaceRooms, numberOfHalls] = value.split('-').map(Number);

        setFilters({
            ...filters,
            numberOfPlaceRooms,
            numberOfHalls,
        });
    };

    return (
        <div className={`md:col-span-1 md:block p-6  space-y-5 border bg-white md:rounded-2xl shadow-xs transition-all duration-300 ease-in-out ${openFilter ? 'xs:translate-x-0 xs:rounded-none  xs:h-screen xs:overflow-y-auto   xs:opacity-100 xs:fixed xs:z-[10001] xs:w-full   xs:mt-0' : 'xs:-translate-x-full xs:opacity-0'} xs:top-0 xs:left-0  md:static md:opacity-100 md:translate-x-0 md:transform-none`}>
            {openFilter && (
                <button
                    onClick={() => setOpenFilter(false)}
                    className=" text-blue-500 text-xl md:hidden xs:block"
                >
                    ✕
                </button>
            )}
            <FilterSection
                title={t("price")}
                options={[
                    { label: '100 - 500', value: '100-500' },
                    { label: '500  - 2,500', value: '500-2500' },
                    { label: '2,500  - 10,000', value: '2500-10000' },
                    { label: '+10,000 ', value: '10000' },
                ]}
                selected={
                    (() => {
                        const { minPrice, maxPrice } = filters;
                        if (minPrice === 10000 && maxPrice === 1000000) return ['10000'];
                        if (minPrice === 100 && maxPrice === 500) return ['100-500'];
                        if (minPrice === 500 && maxPrice === 2500) return ['500-2500'];
                        if (minPrice === 2500 && maxPrice === 10000) return ['2500-10000'];
                        return [];
                    })()
                }
                onChange={handlePriceChange}
            />
            {
                type==="Hall"&&
                <FilterSection
                title={t("duration")}
                options={[
                    { label: t('morning-period'), value: "1" },
                    { label: t('afternoon-period'), value: "2" },
                    
                ]}
               
                 selected={filters.duration !== undefined ? [String(filters.duration)] : []}
                onChange={handleDurationChange}
            />
            }
             

            <FilterSection
                title={type === "Stay" ? t("stay-property-type") : t("event-type")}
                options={subCategories?.map((sub: any) => ({
                    label: sub.title,
                    value: sub.id.toString(),
                }))}
                selected={
                    filters?.subCategoryId
                        ? [filters.subCategoryId.toString()]
                        : []
                }
                onChange={handleTypeChange}
            />
            {type === "Stay" && filters.subCategoryId !== 1 && <FilterSection
                title={t("rooms-and-halls")}
                options={[
                    { label: 'الكل', value: 'all' },
                    { label: '1 + 0', value: '1-0' },
                    { label: '2 + 0', value: '2-0' },
                    { label: '3 + 0', value: '3-0' },
                    { label: '4 + 0', value: '4-0' },
                    { label: '1 + 1', value: '1-1' },
                    { label: '2 + 1', value: '2-1' },
                    { label: '3 + 1', value: '3-1' },
                    { label: '4 + 1', value: '4-1' }

                ]}
                selected={(() => {
                    if (
                        filters.numberOfPlaceRooms !== null &&
                        filters.numberOfPlaceRooms !== undefined &&
                        filters.numberOfHalls !== null &&
                        filters.numberOfHalls !== undefined
                    ) {
                        return [`${filters.numberOfPlaceRooms}-${filters.numberOfHalls}`];
                    }

                    if (
                        filters.numberOfPlaceRooms === null &&
                        filters.numberOfHalls === null
                    ) {
                        return ['all'];
                    }

                    return [];
                })()}

                onChange={handleRoomHallChange}
            />}
            <FilterSection
                title={t("rating")}
                options={[
                    { label: t('no-rate'), value: "0" },
                    { label: '1', value: "1" },
                    { label: '2', value: "2" },
                    { label: '3', value: "3" },
                    { label: '4', value: "4" },
                    { label: '5', value: "5" },
                ]}
                selected={filters.rate !== undefined ? [String(filters.rate)] : []}
                onChange={handleRatingChange}
            />

            <FilterSection
                title={t("services")}
                options={services?.map((ser: any) => ({
                    label: ser.title,
                    value: ser.id.toString(),
                }))}
                selected={filters.services.map(String)}
                onChange={handleFacilityChange}
                showMoreCount={5}
            />

        </div>
    )
}

export default FiltersSidebar
